
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'Footer',
})
export default class extends Vue {
  @Prop({ default: false }) private isFixed!: boolean

  created() {}

  gorecord() {
    window.location.href = 'https://beian.miit.gov.cn'
  }
}
